import { Controller } from '@hotwired/stimulus'
import 'jquery-validation'

// Connects to data-controller="form-validation"
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''
export default class FormValidationController extends Controller {
  connect() {
    this.validationTimers = new Map()
    this.add_validator_methods()
    let form_id = '#' + this.element.getAttribute('id')
    const isNewForm = this.element.id == 'new_user'
    const emailRemote = {
      url: `/onboarding/check_user_email${isNewForm ? '' : '?type=update_user'}`,
      type: 'post',
      // A synchronous request blocks Chrome's main thread for every keystroke.
      async: false
    }

    const phoneRemote = {
      url: `/onboarding/check_user_phone${isNewForm ? '' : '?type=update_user'}`,
      type: 'post',
      // Keep availability checks off the typing path so the phone field remains responsive.
      async: false,
      data: {
        'user[country_code]': () => $('#user_country_code').val()
      }
    }

    const userNameMessage =
      this.element.dataset.isUserform === 'true'
        ? (
          this.element.classList.contains('update-username')
            ? "Please enter your username."
            : "Please enter unique username."
        )
        : "Please enter your email, username, or phone number.";

    const signInForm = $(this.element).hasClass('sign-in-form')
    const preserveInvalidFocus = this.element.dataset.preserveInvalidFocus === 'true'
    $(this.element).validate({
      ignore: ':hidden:not(.timepicker-input), .ignore_validation',
      // On modal forms, repeatedly forcing focus from the submit button back to
      // an invalid field makes the caret visibly flash on every click.
      focusInvalid: !preserveInvalidFocus,
      rules: {
        'user[password]': {
          required: true,
          minlength: this.element.dataset.isUserform == 'true' ? 8 : 1,
          maxlength: 72,
          password: !signInForm
        },
        'showcase[price]': {
          required: true
        },
        'user[website]': {
          customUrl: true
        },
        'user[location]': {
          required: true,
          validCity: true
        },
        'user[current_password]': {
          required: true,
          password: false
        },
        'user[user_name]': {
          required: true,
          ...(!signInForm &&
            { pattern: /^\w+$/ }
          ),
          remote: {
            depends: function (element) {
              return $(element).data('remote') === true
            },
            param: {
              url: '/onboarding/check_user_name',
              type: 'post'
            }
          }
        },
        'user[password_confirmation]': {
          equalTo: '#user_password',
          required: true
        },
        'user[first_name]': {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        'user[last_name]': {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        user_name: {
          remote: {
            url: '/password_reset/check_user',
            type: 'post',
            depends: function (element) {
              return $(element).data('remote') !== true;
            }
          },
        },
        'user[email]': {
          ...(isNewForm ? {
            required: {
              depends() {
                return $('#user_phone_no').val().length === 0
              }
            },
            email_list: true
          } : {
            required: {
              depends() {
                return $('#user_phone_no').val().length === 0
              }
            },
            email: {
              depends() {
                return (this.value?.length !== 0)
              }
            },
            email_list: {
              depends() {
                return (this.value?.length !== 0)
              }
            }
          }),
          remote: emailRemote,
          maxlength: 255
        },
        'user[phone_no]': {
          ...(isNewForm ? {
            required: {
              depends() {
                return $('#user_email').val().length === 0
              }
            }
          } : {
            required: {
              depends() {
                $('#user_email').valid()
                return $('#user_email').val().length === 0
              }
            },
          }),
          remote: phoneRemote
        },
        code: {
          required: true,
          number: true,
          maxlength: 50
        },
        'user[payment_type]': { required: true },
        'user[is_delete]': { required: true },
        'user[delete_account_option]': { required: true },
        'report[report_info_id]': { required: true },
        'report[report_sub_info_id]': { required: true },
        'interest_ids[]': { minchecked: true },
        'admin[password]': {
          required: true,
          minlength: 8,
          maxlength: 72
        },
        'admin[password_confirmation]': {
          equalTo: '#admin_password',
          required: true
        },
        'admin[current_password]': {
          required: true,
          minlength: 8,
          maxlength: 72
        },
        'admin[email]': {
          required: true,
          email: true
        },
        'library_rack[name]': {
          required: true,
          avoidspecialchar: true
        },
        'purchase_backskin[start_date]': {
          required: true,
          futureDate: true
        },
        'purchase_backskin[end_date]': {
          required: true,
          endDateAfterStartDate: '#purchase_backskin_start_date'
        },
        'purchase_backskin[start_time]': {
          required: true,
          invalidTime: true,
          endTimeAfterStartTime: true
        },
        'purchase_backskin[end_time]': {
          required: true,
          invalidTime: true,
          endTimeAfterStartTime: true
        },
        'user[start_time]': {
          invalidTime: true
        },
        'user[end_time]': {
          invalidTime: true
        },
        'user[user_ids][]': {
          required: true
        },
        user_card_id: {
          required: true
        },
        user_address_id: {
          required: true
        },
        'user_address[pin_code]': {
          required: true,
          validPostalCode: true
        },
        'stripe-card-zip': {
          required: true,
          validPostalCode: true
        },
        'stripe-card-expiry': {
          required: true
        },
        verify_otp: {
          required: true,
          digitsOnly: true
        },
        'gallery_folder[name]': {
          required: true
        }
      },
      messages: {
        'admin[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'user[current_password]': {
          required: 'Please enter old password.'
        },
        'user[user_ids][]': {
          required: 'Please select any one.'
        },
        code: {
          required: 'Please enter code.',
          number: 'Please enter only digits.',
          maxlength: 'Please enter code not more than 50 digits.'
        },
        'admin[current_password]': {
          password: "current password doesn't not match."
        },
        'admin[password]': {
          required: 'Please enter your password.',
          password:
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.'
        },
        'admin[password_confirmation]': {
          password: 'Please Enter Same Value Again.'
        },
        'user[password]': {
          required: 'Please enter your password.',
          password:
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.'
        },
        'user[password_confirmation]': {
          password:
            form_id == '#change_password'
              ? 'Confirm password does not match the new password.'
              : 'Confirm password must be match with enter password.',
          equalTo: form_id == '#change_password'
            ? 'Confirm password does not match the new password.'
            : 'Confirm password must be match with enter password.'
        },
        'user[user_name]': {
          required: userNameMessage,
          pattern: 'Only letters, numbers, and underscores are allowed.',
          remote: 'Username already in use.'
        },
        'user[email]': {
          required: isNewForm ? 'Please enter your email address.' : 'Please enter your phone number or email address.',
          email: 'Please enter a valid email address.',
          email_list: 'Please enter a valid email address.',
          remote: 'Email already in use.'
        },
        'update_user[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
          remote: 'Email already in use!'
        },
        'user[phone_no]': {
          required: isNewForm ? 'Please enter your phone number.' : 'Please enter your phone number or email address.',
          remote: 'Phone number already in use.'
        },
        'update_user[phone_no]': {
          required: 'Please enter your Phone number.',
          remote: 'Phone number already in use.'
        },
        user_name: {
          required: userNameMessage,
          remote: "Sorry, We couldn't find account."
        },
        'report[report_info_id]': {
          required: 'Please select one of these options.'
        },
        'report[report_sub_info_id]': {
          required: 'Please select one of these options.'
        },
        user_card_id: {
          required: 'Please select a card for payment.'
        },
        user_address_id: {
          required: 'Please select an address.'
        },
        'user_address[pin_code]': {
          required: 'Please enter postal code.'
        },
        'stripe-card-expiry': {
          required: 'Please enter expiry date.'
        },
        verify_otp: {
          required: 'Please enter verification code.',
          digitsOnly: "Verification code must contain only numbers.",
        },
        'gallery_folder[name]': {
          required: 'Please enter folder name.'
        },
        'library_rack[name]': {
          required: 'Please enter rack name.'
        }
      },
      onkeyup: false, //Only do validations when form focus changes to avoid exessive ASI calls
      onfocusout: function (element, event) {
        if (
          window.skipBlurValidation ||
          (event?.relatedTarget && $(event.relatedTarget).is('.skip-validation')) ||
          $(event.relatedTarget).hasClass('flatpickr-day')
        ) {
          return
        }
        const $el = $(element)
        if (
          $el.is(':input') &&
          !$el.is(':password') &&
          $el.attr('type') !== 'file' &&
          !$el.hasClass('no_leading_space')
        ) {
          $el.val($el.val().trim())
        }
        if (!$el.hasClass('filepond--browser')) $el?.valid()
      },
      errorPlacement: function (error, element) {
        if (element.hasClass('report')) {
          element.closest('.report-list').prepend(error)
        } else if (element.hasClass("timepicker-input")) {
          error.insertAfter(element.closest(".bg-image-btn").parent('div'));
        } else if (
          element.hasClass('language') ||
          element.hasClass('interest')
        ) {
          element.closest('.modal-error').prepend(error)
        } else if (element.hasClass('change-password')) {
          element.closest('div').append(error)
        } else if (element.hasClass('phone-no')) {
          const container = element.closest('.form-group').find('.error-msg')
          container.empty().append(error)
        } else if (element.attr('name') === 'nft[image]') {
          element.closest('.nft_form').find('.required-error').prepend(error)
        } else if (element.attr('name')?.includes('[poll_options_attributes]')) {
          const container = element.closest('.nested-fields')
          container.find('label.error').remove()
          container.append(error)
        } else if (element[0].id == 'user_user_name') {
          element?.closest('div')?.parent()?.find('#content_error')?.html('')
          element?.closest('div')?.parent()?.append(error)
        } else if (element.data('remote') && error[0].innerText != "") {
          const container = element.closest('.form-group').find('#user_name_error')
          if (error[0].innerText !== '') {
            container.html('').append(error)
          }
        } else {
          element.closest('div').parent('div').append(error)
          // $(form_id).find('button').attr('disabled', 'disabled')
        }
      },
      success: function (label, element) {
        if (element.id == 'user_user_name') {
          $('#user_user_name-error')?.remove()
        } else if (element.name?.includes('[poll_options_attributes]')) {
          $(element).closest('.nested-fields').find('label.error').remove()
        }
      }
    })
    $(this.element)
      .find(':input')
      .off('.formValidation')
      .on('input.formValidation', (event) => {
        const element = event.currentTarget

        // on input event remove the error of forgot password field
        if ($(element).data('remote') === true) {
          $(element).closest('.form-group').find('#user_name_error').empty()
        }
        const delay = this.isTypingField(element) ? 800 : 0

        this.clearValidationTimer(element)
        this.validationTimers.set(
          element,
          globalThis.setTimeout(() => {
            this.validationTimers.delete(element)
            this.validateField(element)
          }, delay)
        )
      })
      .on('blur.formValidation', (event) => {
        this.clearValidationTimer(event.currentTarget)
      })
    $('.space_not_required').each(function () {
      $(this).rules('add', {
        regex: true
      })
    })
    $('.no_leading_space').each(function () {
      $(this).rules('add', {
        noLeadingWhitespace: true
      })
    })

    $('#verify_otp, .verify_otp').on('input', function () {
      let form = $(this).closest('form');
      let errorContent = form.find('#content_error')
      if (errorContent.text().trim() === 'Please enter valid verification code.') {
        errorContent.empty();
      }
    })

    // show a validation error when the user exceeds the maximum character limit.
    $('.max-character-valid')
      .off('keydown.maxLength')
      .on('keydown.maxLength', (event) => {
        const element = event.currentTarget
        const maxLength = parseInt(element.getAttribute('maxlength'), 10)

        if (!maxLength) return

        const isCharacterKey =
          event.key.length === 1 &&
          !event.ctrlKey &&
          !event.metaKey &&
          !event.altKey

        if (element.value.length < maxLength || !isCharacterKey) return

        const validator = $(element?.form || element).validate()

        validator.showErrors({
          [element.name]: `Maximum ${maxLength} characters allowed.`
        })
      }
      )

    $(".age18").each(function () {
      $(this).rules("add", {
        age18: true
      });
    });
  }

  disconnect() {
    this.validationTimers?.forEach((timer) => globalThis.clearTimeout(timer))
    this.validationTimers?.clear()
    $(this.element).find(':input').off('.formValidation')
  }

  isTypingField(element) {
  }

  clearValidationTimer(element) {
    const timer = this.validationTimers.get(element)
    if (timer) globalThis.clearTimeout(timer)
    this.validationTimers.delete(element)
  }

  validateField(element) {
    const $el = $(element)
    if ($el.valid()) {
      $el.removeClass('error')
      const container = element.name?.includes('[poll_options_attributes]')
        ? $el.closest('.nested-fields')
        : $el.closest('div')
      container.find('label.error').remove()
    }
  }

  add_validator_methods() {
    $.extend($.validator.messages, {
      required: function (_, element) {
        const $el = $(element)

        const custom = $el.data('custom-error-field')
        if (custom) return custom

        if (!$el.attr('name')) return 'This field is required.'

        const fieldName = extractFieldName($el.attr('name'))

        if (!fieldName) return 'This field is required.'

        switch (element.type) {
          case 'checkbox':
          case 'select-one':
          case 'radio':
            return `Please select ${fieldName.replaceAll('_', ' ')}.`
          case 'file':
            return `Please upload ${fieldName.replaceAll('_', ' ')}.`
        }

        return `Please enter ${fieldName.replaceAll('_', ' ')}.`
      }
    })

    $.validator.addMethod(
      'noLeadingWhitespace',
      function (value, element) {
        return this.optional(element) || !/^\s/.test(value)
      },
      'Spaces are not allowed at the beginning.'
    )

    $.validator.addMethod('password', function (value, element, param) {
      let passwords = value.split(',')
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,255}$/
      for (const password of passwords) {
        const trimmed = password.trim()
        if (!re.test(trimmed)) {
          return false
        }
      }
      return true
    })
    $.validator.addMethod(
      'customUrl',
      function (value, element) {
        return this.optional(element) || isValidUrl(value)
      },
      'Please enter a valid website.'
    )

    $.validator.addMethod(
      'validCity',
      function (value, element) {
        const touched = $(element).data('city-touched')
        if (!touched) return true

        return (
          this.optional(element) ||
          (element._validCity && element.value === element._validCity)
        )
      },
      'Please select a city from the suggestions.'
    )

    $.validator.addMethod(
      'regex',
      function (value, element, regexp) {
        return value == '' || value.trim().length != 0
      },
      'Space not allow'
    )
    $.validator.addMethod(
      'noSpace',
      function (value, element) {
        return this.optional(element) || /^\S+$/i.test(value)
      },
      'Spaces are not allowed.'
    )
    $.validator.addMethod(
      'noSpecialcharacter',
      function (value, element) {
        let names = value.split(',')
        let re = new RegExp(/\W/i)
        for (const name of names) {
          if (re.test(name)) {
            return false
          }
        }
        return true
      },
      "Don't add Special character"
    )
    $.validator.addMethod(
      'avoidspecialchar',
      function (value, element) {
        let names = value.trim().split(',')
        let re = new RegExp(/^\s+|\s+$|[^\w\s]/)
        for (const name of names) {
          if (re.test(name)) {
            return false
          }
        }
        return true
      },
      "Don't add Special character"
    )
    $.validator.addMethod('pattern', function (value, element, param) {
      if (
        this.optional(element) ||
        $(element)?.data('validate-pattern') === false
      ) {
        return true
      }
      if (typeof param === 'string') {
        param = new RegExp('^(?:' + param + ')$')
      }
      return param.test(value)
    })
    $.validator.addMethod('email_list', function (value, element, param) {
      let emails = value.split(',')
      let re = new RegExp(/^[A-Z0-9._%\-\+\~\/]+@([A-Z0-9-]+\.)+[A-Z]+$/i)
      for (const email of emails) {
        if (!re.test((email || "").trim())) {
          return false
        }
      }
      return true
    })
    $.validator.addMethod(
      'endDateAfterStartDate',
      function (value, element, params) {
        const startDateValue = $(params).val()
        if (!startDateValue || !value) return true // don't validate if one is empty

        const start = new Date(startDateValue)
        const end = new Date(value)

        return end >= start
      },
      'End date must be after the start date.'
    )
    $.validator.addMethod(
      'invalidTime',
      function (value, element) {
        return value !== '--:-- --'
      },
      'Please select a valid time.'
    )
    $.validator.addMethod(
      'greaterThan',
      function (value, element, param) {
        const getterMinutes = Number.parseInt(
          $(element).attr('data-greater-minutes') || 0
        )

        const toSeconds = (time) => {
          if (!time) return null

          time = time.trim().toUpperCase()
          const match12 = time.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/)
          if (match12) {
            let [, hour, minute, period] = match12
            hour = parseInt(hour, 10)
            minute = parseInt(minute, 10)
            if (period === "PM" && hour !== 12) hour += 12
            if (period === "AM" && hour === 12) hour = 0

            return hour * 3600 + minute * 60
          }

          const match24 = time.match(/^(\d{1,2}):(\d{2})$/)
          if (match24) {
            const [, hour, minute] = match24
            return parseInt(hour, 10) * 3600 + parseInt(minute, 10) * 60
          }

          return null
        }

        const start = toSeconds($(param).val())
        const end = toSeconds(value)
        if (start === null || end === null) {
          return true
        }

        const requiredGap = getterMinutes * 60
        return end >= start + requiredGap
      },
      function (params, element) {
        const mins = $(element).attr('data-greater-minutes')
        return `End time must be at least ${mins} minutes greater than start time.`
      }
    )
    $.validator.addMethod(
      'futureDate',
      function (value, element) {
        if (!value) return true

        let inputDate = new Date(value)
        let today = new Date()

        today.setHours(0, 0, 0, 0)

        return inputDate > today
      },
      'Please select a future date'
    )
    $.validator.addMethod(
      'endTimeAfterStartTime',
      function (value, element) {
        this.currentElement = element
        let startDate = $("input[name='purchase_backskin[start_date]']").val()
        let endDate = $("input[name='purchase_backskin[end_date]']").val()
        let startTime = $("input[name='purchase_backskin[start_time]']").val()
        let endTime = $("input[name='purchase_backskin[end_time]']").val()

        if (!endTime || !startDate || !endDate || !startTime) return true

        let now = new Date()
        let todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`

        let [sh, sm] = startTime.split(':')
        let [eh, em] = endTime.split(':')

        let startMinutes = +sh * 60 + +sm
        let endMinutes = +eh * 60 + +em
        let currentMinutes = now.getHours() * 60 + now.getMinutes()

        if (
          startDate === todayStr &&
          startMinutes < currentMinutes &&
          element.classList.contains('start_time')
        ) {
          return false
        }

        if (
          endDate === todayStr &&
          endMinutes <= currentMinutes &&
          element.classList.contains('end_time')
        ) {
          return false
        }

        if (
          startDate === endDate &&
          endMinutes <= startMinutes &&
          element.classList.contains('end_time')
        ) {
          return false
        }

        return true
      },
      function () {
        let startDate = $("input[name='purchase_backskin[start_date]']").val()
        let endDate = $("input[name='purchase_backskin[end_date]']").val()

        let now = new Date()
        let todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`

        if (
          startDate === todayStr &&
          this.currentElement.classList.contains('start_time')
        ) {
          return 'Start time must be after current time.'
        }

        if (
          endDate === todayStr &&
          this.currentElement.classList.contains('end_time')
        ) {
          return 'End time must be after current time'
        }

        if (this.currentElement.classList.contains('end_time'))
          return 'End time must be after start time'
      }
    )

    $.validator.addMethod(
      'minchecked',
      function (_value, element, param) {
        const minimum = Number(param)
        return !Number.isFinite(minimum) || checkedCount(element) >= minimum
      },
      function (param) {
        return element.dataset.msgMinchecked || `Please select at least ${param} option${Number(param) === 1 ? '' : 's'}.`
      }
    )

    $.validator.addMethod(
      'maxchecked',
      function (_value, element, param) {
        const maximum = Number(param)
        return !Number.isFinite(maximum) || checkedCount(element) <= maximum
      },
      function (param) {
        return element.dataset.msgMaxchecked || `Please select no more than ${param} option${Number(param) === 1 ? '' : 's'}.`
      }
    )

    $.validator.addMethod("digitsOnly", function (value, element) {
      return this.optional(element) || /^\d+$/.test(value);
    }, "Please enter numbers only.");

    $.validator.addMethod("validPostalCode", function (value, element) {
      return element.dataset.invalid !== 'true';
    }, function (_param, element) {
      if (element.dataset.validating === 'true') return 'Verifying postal code...'
      if (element.dataset.verificationError === 'true') {
        return 'Unable to verify postal code. Please try again.'
      }

      return "Postal code doesn't match the selected location."
    });

    $.validator.addMethod(
      'differentPollOption',
      function (value, element) {
        const currentValue = value.trim().toLowerCase()

        if (!currentValue) return true

        const poll = $(element).closest('[id^="post-poll-"]')
        const options = poll
          .find('input[name*="[poll_options_attributes]"][name$="[answer]"]')
          .filter(function () {
            return $(this)
              .closest('.nested-fields')
              .find('input[name$="[_destroy]"]')
              .val() !== 'true'
          })
        const currentIndex = options.index(element)

        return options
          .slice(0, currentIndex)
          .filter(function () {
            return $(this).val().trim().toLowerCase() === currentValue
          })
          .length === 0
      },
      'This option has already been added.'
    )

    $.validator.addClassRules("max-length-50", {
      required: true,
      maxlength: 50
    });
  }

  clearServerError() {
    const frame = this.element.querySelector('#content_error')
    if (frame) frame.innerHTML = ''
  }
}

function isValidUrl(value) {
  const url = parseUrl(value)
  if (!url) return false

  if (!isHttpProtocol(url)) return false

  const hostname = url.hostname.toLowerCase()

  if (isLocalHostname(hostname)) return false
  if (isPrivateIpv4(hostname)) return false
  if (isLocalIpv6(hostname)) return false
  if (!isPublicDomain(hostname)) return false

  return true
}

function parseUrl(value) {
  try {
    return new URL(value)
  } catch {
    return null
  }
}

function isHttpProtocol(url) {
  return url.protocol === 'http:' || url.protocol === 'https:'
}

function isLocalHostname(hostname) {
  return (
    hostname === 'localhost' ||
    hostname.endsWith('.localhost') ||
    hostname.endsWith('.local')
  )
}

function isPrivateIpv4(hostname) {
  if (!isIpv4(hostname)) return false

  const [a, b] = hostname.split('.').map(Number)

  if (a === 10) return true // 10.0.0.0/8
  if (a === 127) return true // loopback
  if (a === 192 && b === 168) return true // 192.168.0.0/16
  if (a === 169 && b === 254) return true // link-local
  if (a === 172 && b >= 16 && b <= 31) return true // 172.16.0.0 – 172.31.255.255

  return false
}

function isIpv4(hostname) {
  const parts = hostname.split('.')
  if (parts.length !== 4) return false

  return parts.every((part) => {
    if (!/^\d+$/.test(part)) return false
    const num = Number(part)
    return num >= 0 && num <= 255
  })
}

function isLocalIpv6(hostname) {
  return (
    hostname === '::1' || // loopback
    hostname.startsWith('fe80:') || // link-local
    hostname.startsWith('fc') ||
    hostname.startsWith('fd') // unique local
  )
}

function isPublicDomain(hostname) {
  if (!hostname.includes('.')) return false

  const tld = hostname.split('.').pop()
  if (!tld || tld.length < 2) return false

  const specialTlds = new Set(['local', 'localhost', 'test', 'invalid'])
  return !specialTlds.has(tld)
}

function extractFieldName(name) {
  const matches = [...name.matchAll(/\[([^\]]{0,256})\]/g)].map((m) => m[1])

  if (matches.length === 0) return name

  const last = matches.at(-1)
  if (last === '' && matches.length > 1) {
    return matches.at(-2)
  }

  return last
}

function checkedCount(element) {
  if (!element.form || !element.name) return element.checked ? 1 : 0

  return Array.from(element.form.elements).filter((field) => {
    return (
      field.type === 'checkbox' &&
      field.name === element.name &&
      field.checked &&
      !field.disabled
    )
  }).length
}

function handleAjaxResponse(xhr) {
  if (xhr.responseText.includes('<turbo-stream action')) {
    Turbo.renderStreamMessage(xhr.responseText)
  }
}
